import { gql } from '@apollo/client';

const LOAD_NEW_CESSIONS = gql`
  mutation LoadNewCessions {
    loadNewCessions {
      taskId
    }
  }
`;

export default LOAD_NEW_CESSIONS;
